<template>
  <el-upload
    v-loading="loading"
    name="fileData"
    class="uploader-box fl"
    :class="{bigUpload: size === 'big', mediumUpload: size === 'medium'}"
    :action="uploadUrl"
    with-credentials
    accept="image/png,image/jpg,image/jpeg,image/gif,image/bmp"
    :data="otherData"
    :on-success="uploadSuccess"
    :before-upload="beforeUpload"
    :on-remove="removeImg"
    :on-error="uploadError"
    list-type="single-picture"
    :show-file-list="false"
    :file-list="fileList"
    :action-list="actionList"
    :disabled="!canChange"
    :on-preview="onPreview"
  >
    <p v-if="text" slot="tip" class="upload-picture-desc">{{ text }}</p>
    <el-dialog
      :visible.sync="dialogVisible"
      modal-append-to-body
      append-to-body
      lock-scroll
      close-on-click-modal
      class="preview-box"
    >
      <img width="100%" :src="dialogImageUrl" alt="">
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </el-upload>
</template>

<script>
import { certImageOcr } from '@/api/apis/auth';
import { REQUEST_HOST } from '@/api/apiConfig';
import { clstagA } from '@/utils/index';

const typeList = {
  1: {
    infoType: 'idCardData',
    dataType: 'idCardFrontData',
    data: {
      cardNo: '',
      name: '',
      cardType: 1,
    },
  },
  2: {
    infoType: 'idCardData',
    dataType: 'idCardBackData',
    data: {
      isLongTerm: '',
      timeEnd: '',
    },
  },
  3: {
    infoType: 'licenseData',
    dataType: 'licenseData',
    data: {
      companyAddress: '',
      companyAreaId: '',
      companyName: '',
      isLongTerm: '',
      licenseScope: '',
      timeEnd: '',
      uniNo: '',
    },
  },
};
export default {
  name: 'UploadImg',
  components: {
  },
  filters: {
    image(value, width, height) {
      if (!value) return '';
      if (width) return `//img13.360buyimg.com/n5/s${width}x${height}_${value}`;
      return `//img13.360buyimg.com/venderadsman/${value}`;
    },
  },
  props: {
    text: String, // 描述文案
    imageType: Number, // 1 身份证正面, 2 身份证反面, 3 营业执照 -1 无需识别图片
    prop: String, // 更新的数据key
    imgInfo: { // size/demo 等图片信息
      type: Object,
      default: () => ({}),
    },
    fileList: { // 回显已有地址
      type: Array,
      default: () => ([]),
    },
    size: { // 组件展示大小  normal medium big
      type: String,
      default: 'normal',
    },
    canChange: { // 是否可修改
      type: Boolean,
      default: true,
    },
    clstag: String, // 埋点event
  },
  data() {
    return {
      imgUrl: '',
      otherData: {
        fileName: '',
        'fileAuth.app': 'ALL_CHANNELS_NEW_PATHWAY',
        'fileAuth.token': 'SkRfQUxMX0NIQU5ORUxTX05FV19QQVRIV0FZX1VQTE9BRF9GSUxF',
      },
      ocrInfo: {},
      dialogImageUrl: '',
      dialogVisible: false,
      loading: false,
    };
  },
  computed: {
    uploadUrl() {
      return `${REQUEST_HOST}/baccount/workbench/cert/upload`;
    },
    actionList() {
      if (this.canChange) {
        return ['refresh', 'zoom-in']; // 'delete'
      }
      return ['zoom-in'];
    },
  },
  methods: {
    // 上传失败
    uploadError() {
      this.imgUrl = '';
      if (this.imageType !== -1) {
        const currentType = typeList[this.imageType];
        this.ocrInfo[currentType.infoType] = currentType.data;
        this.$emit('updateImg', {
          prop: this.prop,
          imgUrl: this.imgUrl,
          ocrInfo: this.ocrInfo,
          infoType: currentType.infoType,
        });
      } else {
        this.$emit('updateImg', {
          prop: this.prop,
          imgUrl: this.imgUrl,
        });
      }

      this.$message.error('上传失败！请稍后重试！');
    },
    // 成功上传
    uploadSuccess(res) {
      if (res.success) {
        this.imgUrl = res.filePath;

        // // -1 为无需识别的图片：代办人身份证照片、代办人企业授权书
        if (this.imageType !== -1) {
          this.ocrIdentify(res.filePath);
        } else {
          this.$emit('updateImg', {
            prop: this.prop,
            imgUrl: this.imgUrl,
          });
        }
      } else {
        this.uploadError();
      }
    },
    // 资质图片信息ocr识别
    async ocrIdentify(imgPath) {
      this.loading = true;
      const params = {
        imageUrl: imgPath,
        imageType: this.imageType,
      };
      const res = await certImageOcr(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        const currentType = typeList[this.imageType];
        this.ocrInfo[currentType.infoType] = data[currentType.dataType];

        // 如果是长期有效，则将 timeEnd 设置为 null
        if (this.ocrInfo[currentType.infoType].isLongTerm === '1') {
          this.ocrInfo[currentType.infoType].timeEnd = null;
        }

        this.$emit('updateImg', {
          prop: this.prop,
          imgUrl: this.imgUrl,
          ocrInfo: this.ocrInfo,
          infoType: currentType.infoType,
        });
      } else {
        this.uploadError();
        this.$message.error(message || '获取资质信息失败，请稍后重试！');
      }
      this.loading = false;
    },
    // 上传前
    beforeUpload(file) {
      clstagA(`pageclick|keycount|info_legalAuth|upload_${this.clstag}`);
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const image = new Image();
          image.onload = () => {
            let tag = true;
            const isLt = file.size / 1024 <= Number(this.imgInfo.size) * 1024;
            if (!isLt && tag) {
              this.$message({
                message: `上传图片大小不能超过${this.imgInfo.size}MB!`,
                type: 'warning',
              });
              tag = false;
              reject();
            }
            resolve();
          };
          image.src = event.target.result;
        };
        this.otherData.fileName = file.name;
        reader.readAsDataURL(file);
      });
    },
    // 删除图片
    removeImg() {
    },
    // 查看大图
    onPreview(file) {
      clstagA(`pageclick|keycount|info_legalAuth|lookBigImg_${this.clstag}`);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-box {
  img {
    display: block;
  }
}
</style>
<style lang="scss">
.preview-box .el-dialog {
  overflow-y: scroll;
}
.upload-picture-desc {
  padding-top: 5px;
  font-size: 12px;
  line-height: 17px;
  color: rgba(0,0,0,0.85);
  text-align: center;
}
</style>
